module.exports = __webpack_public_path__ + "img/ck.5dadafda.svg";